import { SparklesIcon } from "@heroicons/react/24/outline";

const AiBadge = () => {
  return (
    <div className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-gradient-to-r from-purple-50 to-blue-50 text-purple-700 border border-purple-200 cursor-pointer">
      <SparklesIcon className="w-3.5 h-3.5 text-purple-600" />
      <span className="font-semibold">AI</span>
    </div>
  );
};

export default AiBadge;
